import { ClipLoader } from 'react-spinners'
import { formatNumber, Text } from '../../Dashboard'
import { ReactComponent as Ellipse } from "../assets/ellipse.svg"

const SwapInvoice = ({
    data,
    loading,
    fromCurrency,
    toCurrency,
    onClose,
    onContinue,
}) => {
    return (
        <div className="relative flex items-center justify-center">
            <div className="w-full relative">
                {/* content */}
                <div className="flex flex-col-reverse sm:flex-col gap-4  text-sm ">
                    {loading ? (
                        <div className="relative h-[200px] w-full flex justify-center items-center ">
                            <ClipLoader color='#9f64df ' />
                        </div>
                    ) : (
                        <div className="bg-transparent rounded-xl relative overflow-hidden p-3">
                            {/* <Ellipse className='absolute bottom-0 left-0 ' /> */}
                            {/* main details */}
                            <div className="flex flex-col text-xs lg:text-base gap-4">
                                {/* Input Amount */}
                                <div className="flex justify-between items-center">
                                    <Text tid="inputAmount" />
                                    <span dir="ltr">{`${data.amount} ${fromCurrency.toUpperCase()}`}</span>
                                </div>

                                {/* Unit Price (From) */}
                                <div className="flex justify-between items-center">
                                    <Text tid="unitPriceFrom" />
                                    <span dir="ltr">{data.priceUnitFrom}</span>
                                </div>

                                {/* Unit Price (To) */}
                                <div className="flex justify-between items-center">
                                    <Text tid="unitPriceTo" />
                                    <span dir="ltr">{data.priceUnitTo}</span>
                                </div>

                                {/* Output Before Fee */}
                                <div className="flex justify-between items-center">
                                    <Text tid="outputBeforeFee" />
                                    <span dir="ltr">{`${formatNumber(data.toAmount, { point: 4 })} ${toCurrency.toUpperCase()}`}</span>
                                </div>

                                {/* Fee */}
                                <div className="flex justify-between items-center">
                                    <Text tid="fee" />
                                    <span dir="ltr">{`${formatNumber(data.wage, { point: 4 })} ${toCurrency.toUpperCase()}`}</span>
                                </div>

                                {/* Divider */}
                                {/* <div className='h-[2px] w-full bg-[#292C32] px-2' /> */}

                                {/* Final Amount */}
                                <div className="flex justify-between items-center">
                                    <Text tid="finalAmount" />
                                    <span dir="ltr">{`${formatNumber(data.toAmountAfterWage, { point: 4 })} ${toCurrency.toUpperCase()}`}</span>
                                </div>
                            </div>


                        </div>
                    )}

                    {/* actions */}
                    <div className="flex items-center justify-between gap-3 w-full">
                        <Text
                            tid={"swap-transaction-msg"}
                            dynamicTid={{ amount: formatNumber(data.toAmountAfterWage, { point: 4 }), coin: toCurrency.toUpperCase() }}
                            className='md:w-1/2 hidden md:block' />
                        <div
                            onClick={onContinue}
                            className="shine-btn md:w-1/2 grow text-center bg-gradient-to-r from-[#FC6432] to-[#A855F7] px-6 py-4 rounded-xl shadow cursor-pointer text-white"
                        >
                            {loading ? <ClipLoader size={14} color='#1e1e1e' /> : <Text tid="confirm-swap" className='text-text-white font-semibold ' />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SwapInvoice
